import {
  type FetchProductsResponse as PresApiFetchProductsResponse,
  type GetBreadcrumbsRequest,
} from './aliases';
import { type buildSearchQueryParams } from './helpers';
import {
  type DepopRequestMeta,
  type FetchFilterAggregatesRequest,
} from './types';

import {
  CATEGORY_BREADCRUMBS,
  CATEGORY_SEARCH_SUGGESTIONS,
  FILTER_AGGREGATES,
  PRODUCT_SEARCH_ENDPOINT,
  USERS_SEARCH_ENDPOINT,
} from '@/constants/endpoints';
import { typedHttp } from '@/modules/http';
import { type AxiosCompatibleResponse } from '@/modules/http/types';

type DepopRequestHeaders = {
  ['Depop-Session-Id']?: string;
};

export function depopMetaToHeaders(
  meta: DepopRequestMeta
): DepopRequestHeaders {
  return { ['Depop-Session-Id']: meta.sessionId };
}

export function getCategorySearchSuggestions(query: string, country?: string) {
  return typedHttp.get(CATEGORY_SEARCH_SUGGESTIONS, {
    params: { query, country },
  });
}

export function fetchSearchProducts({
  params,
  searchId,
  sessionId,
}: {
  params: ReturnType<typeof buildSearchQueryParams>;
  searchId: string;
  sessionId?: string | null;
}): Promise<AxiosCompatibleResponse<PresApiFetchProductsResponse>> {
  return typedHttp.get(PRODUCT_SEARCH_ENDPOINT, {
    params,
    withDeviceId: true,
    withAuth: true,
    withUserId: true,
    headers: {
      'Depop-Session-Id': sessionId ?? '',
      'Depop-Search-Id': searchId,
    },
  });
}

export function fetchFilterAggregates({
  params,
  meta,
}: FetchFilterAggregatesRequest) {
  return typedHttp.get(FILTER_AGGREGATES, {
    params,
    withDeviceId: true,
    withAuth: true,
    headers: depopMetaToHeaders(meta),
  });
}

export function fetchCategoryBreadcrumbs(params: GetBreadcrumbsRequest) {
  return typedHttp.get(CATEGORY_BREADCRUMBS, {
    params,
    cache: 'force-cache',
    withGeoHeaders: false,
  });
}

export function fetchUserSearch(query?: string) {
  return typedHttp.get(USERS_SEARCH_ENDPOINT, {
    params: { query },
  });
}
